import { z } from "zod";
import { createRoute, Outlet } from "@tanstack/react-router";
import { AdminSignIn } from "./AdminSignIn";
import { SelectAccount } from "./SelectAccount";
import { RequestPasswordReset } from "./PasswordReset";
import { ChangePassword } from "./ChangePassword";
import { RequestEmailVerification } from "./EmailVerification";
import { ConfirmEmail } from "./ConfirmEmail";
import { AuthLayout } from "../../layouts/AuthLayout";
import { accountRoutes, adminRoutes, userRoutes } from "../../App";
import { memo } from "react";
import { AcceptInvitation } from "./AcceptInvitation";
import { RegisterUser } from "./RegisterUser";
import { UserSignIn } from "./UserSignIn";

const adminAuthLayoutRoute = createRoute({
  getParentRoute: () => adminRoutes,
  id: "root-auth",
  component: memo(() => {
    return (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    );
  }),
});

const adminSignInRoute = createRoute({
  getParentRoute: () => adminAuthLayoutRoute,
  path: "/sign-in",
  component: AdminSignIn,
});
const adminSelectAccountRoute = createRoute({
  getParentRoute: () => adminAuthLayoutRoute,
  path: "/select-account",
  component: SelectAccount,
});
const adminResetPassRoute = createRoute({
  getParentRoute: () => adminAuthLayoutRoute,
  path: "/reset-password",
  component: RequestPasswordReset,
});
const adminChangePassRoute = createRoute({
  getParentRoute: () => adminAuthLayoutRoute,
  path: "/change-password/$token",
  component: ChangePassword,
});
const adminConfirmEmailRoute = createRoute({
  getParentRoute: () => adminAuthLayoutRoute,
  path: "/confirm-email/$token",
  component: ConfirmEmail,
});
const adminRequestConfirmEmailRoute = createRoute({
  getParentRoute: () => adminAuthLayoutRoute,
  path: "/email-verification",
  component: RequestEmailVerification,
});

export const adminAuthRoutes = adminAuthLayoutRoute.addChildren([
  adminSignInRoute,
  adminSelectAccountRoute,
  adminResetPassRoute,
  adminChangePassRoute,
  adminConfirmEmailRoute,
  adminRequestConfirmEmailRoute,
]);

const userAuthLayoutRoute = createRoute({
  getParentRoute: () => userRoutes,
  id: "user-auth",
  component: () => {
    return (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    );
  },
});

const accountAuthLayoutRoute = createRoute({
  getParentRoute: () => accountRoutes,
  id: "account-auth",
  component: () => {
    return (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    );
  },
});

const userSignInRoute = createRoute({
  getParentRoute: () => userAuthLayoutRoute,
  path: "/sign-in",
  component: UserSignIn,
  validateSearch: z.object({
    shouldVerifyEmail: z.boolean().optional(),
  }),
});

const accountSignInRoute = createRoute({
  getParentRoute: () => accountAuthLayoutRoute,
  path: "/sign-in",
  component: UserSignIn,
  validateSearch: z.object({
    shouldVerifyEmail: z.boolean().optional(),
  }),
});

const userSelectAccountRoute = createRoute({
  getParentRoute: () => userAuthLayoutRoute,
  path: "/select-account",
  component: SelectAccount,
});
const userResetPassRoute = createRoute({
  getParentRoute: () => userAuthLayoutRoute,
  path: "/reset-password",
  component: RequestPasswordReset,
});
const userChangePassRoute = createRoute({
  getParentRoute: () => userAuthLayoutRoute,
  path: "/change-password/$token",
  component: ChangePassword,
});
const userRegisterRoute = createRoute({
  getParentRoute: () => userAuthLayoutRoute,
  path: "/register",
  component: RegisterUser,
});
const userConfirmEmailRoute = createRoute({
  getParentRoute: () => userAuthLayoutRoute,
  path: "/confirm-email/$token",
  component: ConfirmEmail,
});
const userRequestConfirmEmailRoute = createRoute({
  getParentRoute: () => userAuthLayoutRoute,
  path: "/email-verification",
  component: RequestEmailVerification,
});
const userAcceptInvitationRoute = createRoute({
  getParentRoute: () => userAuthLayoutRoute,
  path: "/accept-invitation/$token",
  component: AcceptInvitation,
});

export const userAuthRoutes = userAuthLayoutRoute.addChildren([
  userSignInRoute,
  userSelectAccountRoute,
  userResetPassRoute,
  userChangePassRoute,
  userRegisterRoute,
  userConfirmEmailRoute,
  userRequestConfirmEmailRoute,
  userAcceptInvitationRoute,
]);

export const accountAuthRoutes = accountAuthLayoutRoute.addChildren([
  accountSignInRoute,
]);
